/**
 * 软提醒常驻告警条（class-scheduling，T03 交互规则：软提醒保持在页面上，
 * 用户点击「知道了」手动关闭，不自动消失）。
 *
 * 用于发布排课等成功操作的伴随软提醒（超出教师可排课时段/命中临时例外/
 * 同日跨校区）：多条逐行渲染，closeText 固定「知道了」。
 * 原型为 message.warning 自动关闭，本组件为用户确认的交互增强（2026-08-20）。
 */
import { Alert } from 'antd';

export interface SoftWarningItem {
  type: string;
  dayOfWeek: number;
  message: string;
}

export function SoftWarningsAlert({
  warnings,
  onAcknowledge,
}: {
  warnings: SoftWarningItem[];
  onAcknowledge: () => void;
}) {
  if (warnings.length === 0) return null;
  return (
    <Alert
      type="warning"
      showIcon
      closable
      closeText="知道了"
      style={{ marginBottom: 12 }}
      message={`已发布，但有 ${warnings.length} 条软提醒`}
      description={
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          {warnings.map((w, i) => (
            <li key={i}>{w.message}</li>
          ))}
        </ul>
      }
      onClose={onAcknowledge}
    />
  );
}
